import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';
import {getStructure, listStructures, listDataDictionaries} from '../utils/utilsDataDictionary';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 



class SelectStructure extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();

        this.handleChange = this.handleChange.bind(this);
    
    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectDataDictionary: false,
            label: "Structure",
            idSelected: "",
            idDataDictionary: null,
            onChange: null
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectDataDictionary = getParam('selectDataDictionary',this.props);
        StateChange.idDataDictionary = getParam('idDataDictionary', this.props);        
        StateChange.idSelected = getParam('value', this.props);
        StateChange.onChange = getParam('onChange', this.props);


        if (StateChange.selectDataDictionary){
            this.loadDataDictionaries();
        }
        
        if (StateChange.idDataDictionary){
            this.loadStructures(StateChange.idDataDictionary);
        }

        if (StateChange.idSelected){
            this.loadSelectedStructure(StateChange.idSelected);
        }

        this.setState(StateChange);

    }

    loadSelectedStructure(idStructure){

        if (!idStructure){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (Structure) => {
            const StateChange = {
                SelectedStructure: Structure,
                renderState: "loaded"
            };
            
            if (Structure.DataDictionary){
                StateChange.idDataDictionary = Structure.DataDictionary._id;
                this.loadStructures(StateChange.idDataDictionary);

            }
            
            this.setState(StateChange);
            
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load structure"
            });
        };
        getStructure(this.dsd, idStructure, onLoad, onFail);
        
    };



    loadStructures(idDataDictionary){

        if (!idDataDictionary){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (structures) => {
            this.setState({
                Structures: structures,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load structures"
            });
        };

        listStructures(this.dsd, {idDataDictionary: idDataDictionary}, onLoad, onError);
        
    };


    loadDataDictionaries(){

        this.setState({renderState: "loading"});

        const onLoad = (dataDictionaries) => {
            this.setState({
                DataDictionaries: dataDictionaries,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load data dictionaries"
            });
        };

        listDataDictionaries(this.dsd, {}, onLoad, onError);
        
    };



    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idDataDictionary":
                this.setState({"idDataDictionary":FormFieldValue});
                if (FormFieldValue){
                    this.loadStructures(FormFieldValue);
                }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectDataDictionary && this.state.DataDictionaries &&
                            <PD.Select label='Select a Data Dictionary' name='idDataDictionary' onChange={this.handleChange} value={this.state.idDataDictionary}>
                                {
                                    this.state.DataDictionaries.map(
                                        (DataDictionary, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={DataDictionary._id}>{DataDictionary.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.Structures &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Structures.map(
                                        (Structure, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Structure._id}>{Structure.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectStructure_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectStructure {...props} navigation={navigation} location={location} params={params} />;
  }
